import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { taiwanAddress } from "../common/TaiwanAddress";
import { sendCode, signUp, loginMember } from "../../actions/authActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from "../../validation/is-empty";
import styles from './signup.module.css';

class SignUpPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      code: "", 
      member_name: "", 
      gender: "", 
      birthday: "", 
      area: "", 
      email: "", 
      password: "", 
      confirmPassword: "",
      btnSend: -50,
      btnStatus: false,
      btnSec: 0,
      birthdayType: "text",
      showModal: "",
      showModalSendCode: "",
      showModalBackdrop: "",
      error: {}
    };

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.handleCloseModalSendCode = this.handleCloseModalSendCode.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.sendCode = this.sendCode.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      let btnSend = -50;
      if (this.props.errors.phone) {
        btnSend = -79;
      }
      this.setState({ error: this.props.errors, btnSend: btnSend });
    }

    if (this.props.code !== prevProps.code) {
      if(this.props.code.msg && this.props.code.msg === "Send Code OK") {
        this.setState({ showModalSendCode: "show", showModalBackdrop: "modal-backdrop show", btnStatus: true });

        let timeOutId2;
        let cnt = 0;
        timeOutId2 = setInterval(() => {
          this.setState({ btnSec: 600-cnt });
          cnt++;

          if(cnt > 600 ){
            clearInterval(timeOutId2);
            return;
          }
        }, 1000);

        let timeOutId;
        timeOutId = setTimeout(() => {
          this.setState({ btnStatus: false, btnSec: 0 });
          clearTimeout(timeOutId);
          return;
        }, 600000);
      }
    }

    if (this.props.result !== prevProps.result) {
      if (this.props.result.msg && this.props.result.msg === "SignUp OK") {
        this.setState({ showModal: "show", showModalBackdrop: "modal-backdrop show" });
      }
    }
  };

  handleCloseModalSendCode() {
    this.setState({ showModalSendCode: "", showModalBackdrop: "" });
  }

  handleCloseModal() {
    this.setState({ showModal: "", showModalBackdrop: "" });

    const { phone, password } = this.state;
    this.props.loginMember({phone: phone, password: password});
    this.props.history.push("/members");
  }

  sendCode(e) {
    e.preventDefault();
    const { phone } = this.state;

    let error = {};
    let btnSend = -50;
    if (isEmpty(phone)) {
      error.phone= "請輸入手機號碼";
      btnSend = -79;
    } else {
      const re = new RegExp(/^[0-9]/);
      if (!re.test(phone)) {
        error.phone= "手機號碼只能輸入數字";
        btnSend = -79;
      }
    }

    if (!isEmpty(error)){
      this.setState({ error: error, btnSend: btnSend });
    } else {
      this.setState({ error: {}, btnSend: btnSend });
      this.props.sendCode({phone: phone});
    }
  }

  onClick(e) {
    e.preventDefault();
    const { phone, code, member_name, gender, birthday, area, email, password, confirmPassword } = this.state;

    let error = {};
    let btnSend = -50;
    if (isEmpty(phone)) {
      error.phone= "請輸入手機號碼";
      btnSend = -79;
    } else {
      const re = new RegExp(/^[0-9]/);
      if (!re.test(phone)) {
        error.phone= "手機號碼只能輸入數字";
        btnSend = -79;
      }
    }

    if (isEmpty(code)) {
      error.code= "請輸入驗證碼";
    }

    if (isEmpty(member_name)) {
      error.member_name= "請輸入姓名";
    }

    if (isEmpty(gender)) {
      error.gender= "請選擇性別";
    }

    if (isEmpty(birthday)) {
      error.birthday= "請輸入生日";
    }

    if (isEmpty(area)) {
      error.area= "請選擇居住地";
    }

    if (isEmpty(email)) {
      error.email= "請輸入 E-Mail";
    }

    if (isEmpty(password)) {
      error.password= "請輸入密碼";
    }

    if (isEmpty(confirmPassword)) {
      error.confirmPassword= "請再次輸入密碼";
    }

    if (password !== confirmPassword) {
      error.confirmPassword = "兩次密碼輸入不一致。";
    }

    if (!isEmpty(error)){
      this.setState({ error: error, btnSend: btnSend });
    } else {
      this.setState({ error: {}, btnSend: btnSend });
      let data = { phone, code, member_name, gender, birthday, area, email, password, confirmPassword };
      this.props.signUp(data);
    }
  };

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocus(e) {
    this.setState({ birthdayType: "date" });
  }

  onBlur(e) {
    this.setState({ birthdayType: "text" });
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { error, phone, code, member_name, gender, birthday, area, email, password, confirmPassword, btnSend, btnStatus, btnSec, birthdayType, showModalSendCode, showModal, showModalBackdrop } = this.state;
    const yyIndex_min = new Date().getFullYear()-79;
    const yyIndex_max = new Date().getFullYear()-18;
    const mm = new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1;
    const dd = new Date().getDate() < 10 ? '0'+(new Date().getDate()) : new Date().getDate();

    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(!isAuthTokenValid) && (
        <div id="page">
          <Navbar showLogin={true} />
          <div className="colorlib">
            <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                    <h1 style={{color: "#fff", fontWeight: "700", textAlign: "center", margin: "30px 0px 60px"}}>歡迎！立即加入會員</h1>
                    <div className="form-container">
                      <form>

                        <div className={styles["form-group"]}>
                          <input id="phone" name="phone" className="form-control" type="text" placeholder="手機號碼" required="required" value={phone} onChange={this.onChange} />
                          {error.phone && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.phone}</span> )} 
                        </div>
                        <button type="button" id="button-send" className={styles["btn-send"]} style={{top: `${btnSend}px`, backgroundColor: `${btnStatus?"#787878":"#F6490D"}`}} onClick={this.sendCode} disabled={btnStatus}>{`傳送驗證碼${btnSec===0?"":`(${btnSec})`}`}</button>

                        <div className={styles["form-group"]}>
                          <input id="code" name="code" className="form-control" style={{marginTop: "-45px"}} type="text" placeholder="驗證碼" required="required" value={code} onChange={this.onChange} />
                          {error.code && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.code}</span> )} 
                        </div>   

                        <div className={styles["form-group"]}>
                          <input id="member_name" name="member_name" className="form-control" type="text" placeholder="姓名" required="required" value={member_name} onChange={this.onChange} />
                          {error.member_name && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.member_name}</span> )} 
                        </div>    

                        <div className={styles["form-group"]}>
                          <select type="text" className={styles["pretty-select"]} id="gender" name="gender" value={gender} onChange={this.onChange}>
                            <option value="">請選擇性別</option>
                            <option value="x">中性</option>
                            <option value="m">男性</option>
                            <option value="f">女性</option>
                          </select>
                          {error.gender && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.gender}</span> )} 
                        </div>

                        <div className={styles["form-group"]}>
                          <input id="birthday" name="birthday" placeholder="生日(2000/01/01)" className="form-control" type={birthdayType} value={birthday} /*min={`${yyIndex_min}-01-01`} max={`${yyIndex_max}-${mm}-${dd}`} onFocus={this.onFocus} onBlur={this.onBlur}*/ onChange={this.onChange} />
                          {error.birthday && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.birthday}</span> )} 
                        </div>

                        <div className={styles["form-group"]}>
                          <select type="text" className={styles["pretty-select"]} id="area" name="area" value={area} onChange={this.onChange}>
                            <option value="">請選擇居住地</option>
                            {Object.keys(taiwanAddress).map(addressKey => (
                              <option key={`area- ${addressKey}`} value={addressKey}>
                                {addressKey}
                              </option>
                            ))}
                            <option key={`area- 香港`} value="香港">
                              香港
                            </option>
                            <option key={`area- 澳門`} value="澳門">
                              澳門
                            </option>
                            <option key={`area- 其它`} value="其它">
                              其它
                            </option>
                          </select>
                          {error.area && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.area}</span> )} 
                        </div>

                        <div className={styles["form-group"]}>
                          <input name="email" className="form-control" type="email" placeholder="E-Mail" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required="required" value={email} onChange={this.onChange} />
                          {error.email && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.email}</span> )} 
                        </div>

                        <div className={styles["form-group"]}>
                          <input id="password" name="password" className="form-control" type="password" placeholder="設定密碼(格式:含英數至少八個字元)" pattern="^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$" required="required" value={password} onChange={this.onChange} />
                          {error.password && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.password}</span> )}   
                        </div>

                        <div className={styles["form-group"]}>
                          <input id="confirmPassword" name="confirmPassword" className="form-control" type="password" placeholder="確認密碼" required="required" value={confirmPassword} onChange={this.onChange} />
                          {error.confirmPassword && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.confirmPassword}</span> )}   
                        </div>

                        <div className="form-group list">
                            <input type="button" value="註冊" className="btn btn-danger btn-block" onClick={this.onClick} />
                        </div>

                        <h5 style={{color: "#fff"}}>點擊註冊，即表示您已閱讀並同意<br/><a href="/game/complete_agreement" target="_blank">會員服務暨個資隱私權同意書</a></h5>
                      </form>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModalSendCode}`} id="myModalSendCode" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={{width: "350px", margin: "50px auto"}}>
                    <div className="modal-content"> 
                        <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                            <h3>驗證碼已發送完成</h3>
                            <p>請到您的手機查看，10分鐘有效</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModalSendCode}>關閉</button>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModal}`} id="myModal" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={{width: "350px", margin: "50px auto"}}>
                    <div className="modal-content"> 
                        <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                            <h3>恭喜您註冊完成</h3>
                            <p>請到您的信箱啟動驗證信件，10分鐘有效</p>
                        </div>
                        <div className="modal-footer" style={{textAlign: "center", border: "0"}}>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModal}>完成</button>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          <Footer showAgreement={true} />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

SignUpPage.propTypes = {
  sendCode: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
  loginMember: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  errors: state.errors,
  code: state.auth.sendCodeResult,
  result: state.auth.signUpResult
});

export default connect(mapStateToProps, { sendCode, signUp, loginMember })(SignUpPage);